import React from "react";

const PageShippingDeliveryPolicy = () => {
  return (
    <div>
      {" "}
      <div className="max-w-4xl mx-auto rounded-lg p-8">
        <h1 className="text-3xl font-bold mb-4">Shipping & Delivery Policy</h1>
        <p className="text-sm text-gray-500 mb-6">
          Last updated on Jul 4th 2025
        </p>

        <p className="mb-4">
          For International buyers, orders are shipped and delivered through
          registered international courier companies and/or International speed
          post only. For domestic buyers, orders are shipped through registered
          domestic courier companies and /or speed post only.
        </p>

        <p className="mb-4">
          Orders are shipped within 1-2 days or as per the delivery date agreed
          at the time of order confirmation and delivering of the shipment takes
          1 to 3 days and depending on the mode and type of courier selected by
          buyer during order confirmation and subject to Courier Company / post
          office norms.
        </p>

        <p className="mb-4">
          VIJAYDEEP MOULD ACCESSORIES PRIVATE LIMITED is not liable for any
          delay in delivery by the courier company / postal authorities and only
          guarantees to hand over the consignment to the courier company or
          postal authorities within 1-2 days from the date of the order and
          payment or as per the delivery date agreed at the time of order
          confirmation. Delivery of all orders will be made to the address
          provided by the buyer. Delivery of our services will be confirmed on
          your mail ID as specified during registration. For any issues in
          utilizing our services you may contact our helpdesk on{" "}
          <a href="tel:9082677909" className="text-blue-600 underline">
            9082677909
          </a>{" "}
          or{" "}
          <a
            href="mailto:support@vijaydeep.in"
            className="text-blue-600 underline"
          >
            support@vijaydeep.in
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PageShippingDeliveryPolicy;
